<template>
  <div>
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step4.makeUpWaterMeter`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.makeUpWaterMeter"
          :label="$t('treatmentProgram.step4.yesOrNo')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="makeUpWaterMeter"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- link to controler -->
    <v-row
      v-if="isTrue(data.makeUpWaterMeter)"
      class="xPadding"
    >
      <v-col
        class="noYPadding"
        cols="12"
      >
        <p class="titleModal mb-1">
          {{
            $t(`treatmentProgram.step4.linkToMeter`)
          }}
        </p>
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
      >
        <VSelect
          v-model="data.makeUpWaterLinkToControler"
          :label="$t('treatmentProgram.step4.yesOrNo')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="makeUpWaterLinkToControler"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End link to controler -->
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step4.blowdownWaterMeter`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.blowdownWaterMeter"
          :label="$t('treatmentProgram.step4.yesOrNo')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="blowdownWaterMeter"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- link to blowdown -->
    <v-row
      v-if="isTrue(data.blowdownWaterMeter)"
      class="xPadding"
    >
      <v-col
        class="noYPadding"
        cols="12"
      >
        <p class="titleModal mb-1">
          {{
            $t(`treatmentProgram.step4.linkToMeter`)
          }}
        </p>
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
      >
        <VSelect
          v-model="data.blowdownWaterMeterLinkToControler"
          :label="$t('treatmentProgram.step4.yesOrNo')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="blowdownWaterMeterLinkToControler"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End link to controler -->
    <!-- controler -->
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step4.controler`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
      >
        <VTextField
          v-model="data.mark"
          :label="$t('treatmentProgram.step4.mark')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
      >
        <VTextField
          v-model="data.model"
          :label="$t('treatmentProgram.step4.model')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- functionality -->
    <div class="box addTreatmentProgramBox">
      <p class="xPadding titleModal">
        {{
          $t(`treatmentProgram.step4.functionality`)
        }}
      </p>
      <v-row
        v-for="(key, index) in keys"
        :key="index"
        class="xPadding"
      >
        <v-col class="noYPadding">
          <v-checkbox
            v-model="data[key]"
            class="check"
            hideDetails
            :label="$t(`treatmentProgram.step4.${key}`)"
            color="primary"
            @change="updateData"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="data.other"
        class="xPadding"
      >
        <v-col
          class=""
          cols="12"
        >
          <VTextField
            v-model="data.otherInfo"
            :label="$t('treatmentProgram.step4.specify')"
            class="text-field-transparent"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'ProgramControl',
    components: {
        VTextField,
    },
    props: {
        programControl: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            keys: [
                'blowdown',
                'conductivity',
                'ph',
                'temperature',
                'orp',
                'fluorometer',
                'corossionMeter',
                'internetConnection',
                'other',
            ],
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
    },
    watch: {
        programControl: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.programControl) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { programControl: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type] ? this.treatmentProgramUnits[type] : [];
        },
        isTrue(property) {
            return property === 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.btn-container {
  display: flex;
  align-items: baseline;
  padding: 0;
}
.noYPadding {
  padding-bottom: 0px;
  padding-top: 0px;
}
.check {
    border: 1px solid #8D969F;
    border-radius: 4px;
    padding: 10px 5px;
    height: 56px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
